/* eslint-disable prettier/prettier */
import type { AdonisEndpoint } from '@tuyau/core/types'
import type { Registry } from './schema.d.ts'
import type { ApiDefinition } from './tree.d.ts'

const placeholder: any = {}

const routes = {
  'stores.fridge_stores': {
    methods: ["GET","HEAD"],
    pattern: '/stores/fridge-stores',
    tokens: [{"old":"/stores/fridge-stores","type":0,"val":"stores","end":""},{"old":"/stores/fridge-stores","type":0,"val":"fridge-stores","end":""}],
    types: placeholder as Registry['stores.fridge_stores']['types'],
  },
  'stores.show_actives_and_used_categories': {
    methods: ["GET","HEAD"],
    pattern: '/stores/:id/categories/actives-and-used',
    tokens: [{"old":"/stores/:id/categories/actives-and-used","type":0,"val":"stores","end":""},{"old":"/stores/:id/categories/actives-and-used","type":1,"val":"id","end":""},{"old":"/stores/:id/categories/actives-and-used","type":0,"val":"categories","end":""},{"old":"/stores/:id/categories/actives-and-used","type":0,"val":"actives-and-used","end":""}],
    types: placeholder as Registry['stores.show_actives_and_used_categories']['types'],
  },
  'stores.get_dashboard_kpis': {
    methods: ["GET","HEAD"],
    pattern: '/stores/get-all-kpis',
    tokens: [{"old":"/stores/get-all-kpis","type":0,"val":"stores","end":""},{"old":"/stores/get-all-kpis","type":0,"val":"get-all-kpis","end":""}],
    types: placeholder as Registry['stores.get_dashboard_kpis']['types'],
  },
  'stores.get_today_data': {
    methods: ["GET","HEAD"],
    pattern: '/stores/:id/today-datas',
    tokens: [{"old":"/stores/:id/today-datas","type":0,"val":"stores","end":""},{"old":"/stores/:id/today-datas","type":1,"val":"id","end":""},{"old":"/stores/:id/today-datas","type":0,"val":"today-datas","end":""}],
    types: placeholder as Registry['stores.get_today_data']['types'],
  },
  'stores.get_carts_data': {
    methods: ["GET","HEAD"],
    pattern: '/stores/:storeId/carts-data',
    tokens: [{"old":"/stores/:storeId/carts-data","type":0,"val":"stores","end":""},{"old":"/stores/:storeId/carts-data","type":1,"val":"storeId","end":""},{"old":"/stores/:storeId/carts-data","type":0,"val":"carts-data","end":""}],
    types: placeholder as Registry['stores.get_carts_data']['types'],
  },
  'stores.get_promo_codes_data': {
    methods: ["GET","HEAD"],
    pattern: '/stores/get-promos-datas/:dateStart/:dateEnd/:ids',
    tokens: [{"old":"/stores/get-promos-datas/:dateStart/:dateEnd/:ids","type":0,"val":"stores","end":""},{"old":"/stores/get-promos-datas/:dateStart/:dateEnd/:ids","type":0,"val":"get-promos-datas","end":""},{"old":"/stores/get-promos-datas/:dateStart/:dateEnd/:ids","type":1,"val":"dateStart","end":""},{"old":"/stores/get-promos-datas/:dateStart/:dateEnd/:ids","type":1,"val":"dateEnd","end":""},{"old":"/stores/get-promos-datas/:dateStart/:dateEnd/:ids","type":1,"val":"ids","end":""}],
    types: placeholder as Registry['stores.get_promo_codes_data']['types'],
  },
  'stores.index_checkin_kiosks': {
    methods: ["GET","HEAD"],
    pattern: '/stores/:storeId/checkins',
    tokens: [{"old":"/stores/:storeId/checkins","type":0,"val":"stores","end":""},{"old":"/stores/:storeId/checkins","type":1,"val":"storeId","end":""},{"old":"/stores/:storeId/checkins","type":0,"val":"checkins","end":""}],
    types: placeholder as Registry['stores.index_checkin_kiosks']['types'],
  },
  'stores.index_checkout_kiosks': {
    methods: ["GET","HEAD"],
    pattern: '/stores/:storeId/checkouts',
    tokens: [{"old":"/stores/:storeId/checkouts","type":0,"val":"stores","end":""},{"old":"/stores/:storeId/checkouts","type":1,"val":"storeId","end":""},{"old":"/stores/:storeId/checkouts","type":0,"val":"checkouts","end":""}],
    types: placeholder as Registry['stores.index_checkout_kiosks']['types'],
  },
  'products.associable_aliases': {
    methods: ["GET","HEAD"],
    pattern: '/products/associable-aliases',
    tokens: [{"old":"/products/associable-aliases","type":0,"val":"products","end":""},{"old":"/products/associable-aliases","type":0,"val":"associable-aliases","end":""}],
    types: placeholder as Registry['products.associable_aliases']['types'],
  },
  'products.show_minimum_stock': {
    methods: ["GET","HEAD"],
    pattern: '/products/:id/minimum-stock',
    tokens: [{"old":"/products/:id/minimum-stock","type":0,"val":"products","end":""},{"old":"/products/:id/minimum-stock","type":1,"val":"id","end":""},{"old":"/products/:id/minimum-stock","type":0,"val":"minimum-stock","end":""}],
    types: placeholder as Registry['products.show_minimum_stock']['types'],
  },
  'products.get_multiple_articles': {
    methods: ["GET","HEAD"],
    pattern: '/products/get-multiple-articles',
    tokens: [{"old":"/products/get-multiple-articles","type":0,"val":"products","end":""},{"old":"/products/get-multiple-articles","type":0,"val":"get-multiple-articles","end":""}],
    types: placeholder as Registry['products.get_multiple_articles']['types'],
  },
  'products.get_product_stock': {
    methods: ["GET","HEAD"],
    pattern: '/products/:reference/stock',
    tokens: [{"old":"/products/:reference/stock","type":0,"val":"products","end":""},{"old":"/products/:reference/stock","type":1,"val":"reference","end":""},{"old":"/products/:reference/stock","type":0,"val":"stock","end":""}],
    types: placeholder as Registry['products.get_product_stock']['types'],
  },
  'products.block_or_unblock_lots': {
    methods: ["POST"],
    pattern: '/products/handle-block-lots',
    tokens: [{"old":"/products/handle-block-lots","type":0,"val":"products","end":""},{"old":"/products/handle-block-lots","type":0,"val":"handle-block-lots","end":""}],
    types: placeholder as Registry['products.block_or_unblock_lots']['types'],
  },
  'products.add_comment_to_lots': {
    methods: ["POST"],
    pattern: '/products/comment-lots',
    tokens: [{"old":"/products/comment-lots","type":0,"val":"products","end":""},{"old":"/products/comment-lots","type":0,"val":"comment-lots","end":""}],
    types: placeholder as Registry['products.add_comment_to_lots']['types'],
  },
  'products.get_associations': {
    methods: ["GET","HEAD"],
    pattern: '/products/:id/associations',
    tokens: [{"old":"/products/:id/associations","type":0,"val":"products","end":""},{"old":"/products/:id/associations","type":1,"val":"id","end":""},{"old":"/products/:id/associations","type":0,"val":"associations","end":""}],
    types: placeholder as Registry['products.get_associations']['types'],
  },
  'products.add_association': {
    methods: ["POST"],
    pattern: '/products/:id/associations',
    tokens: [{"old":"/products/:id/associations","type":0,"val":"products","end":""},{"old":"/products/:id/associations","type":1,"val":"id","end":""},{"old":"/products/:id/associations","type":0,"val":"associations","end":""}],
    types: placeholder as Registry['products.add_association']['types'],
  },
  'products.remove_association': {
    methods: ["DELETE"],
    pattern: '/products/:id/associations/:associationId',
    tokens: [{"old":"/products/:id/associations/:associationId","type":0,"val":"products","end":""},{"old":"/products/:id/associations/:associationId","type":1,"val":"id","end":""},{"old":"/products/:id/associations/:associationId","type":0,"val":"associations","end":""},{"old":"/products/:id/associations/:associationId","type":1,"val":"associationId","end":""}],
    types: placeholder as Registry['products.remove_association']['types'],
  },
  'stores.get_lots_data': {
    methods: ["GET","HEAD"],
    pattern: '/quality/lots',
    tokens: [{"old":"/quality/lots","type":0,"val":"quality","end":""},{"old":"/quality/lots","type":0,"val":"lots","end":""}],
    types: placeholder as Registry['stores.get_lots_data']['types'],
  },
  'stores.get_articles_data': {
    methods: ["GET","HEAD"],
    pattern: '/quality/articles',
    tokens: [{"old":"/quality/articles","type":0,"val":"quality","end":""},{"old":"/quality/articles","type":0,"val":"articles","end":""}],
    types: placeholder as Registry['stores.get_articles_data']['types'],
  },
  'stores.get_lot_details': {
    methods: ["GET","HEAD"],
    pattern: '/quality/:lot',
    tokens: [{"old":"/quality/:lot","type":0,"val":"quality","end":""},{"old":"/quality/:lot","type":1,"val":"lot","end":""}],
    types: placeholder as Registry['stores.get_lot_details']['types'],
  },
  'users.index_app': {
    methods: ["GET","HEAD"],
    pattern: '/users/index-app',
    tokens: [{"old":"/users/index-app","type":0,"val":"users","end":""},{"old":"/users/index-app","type":0,"val":"index-app","end":""}],
    types: placeholder as Registry['users.index_app']['types'],
  },
  'users.payment_default_users': {
    methods: ["GET","HEAD"],
    pattern: '/users/payment-default',
    tokens: [{"old":"/users/payment-default","type":0,"val":"users","end":""},{"old":"/users/payment-default","type":0,"val":"payment-default","end":""}],
    types: placeholder as Registry['users.payment_default_users']['types'],
  },
  'carts.list_carts_with_images': {
    methods: ["GET","HEAD"],
    pattern: '/carts-with-images',
    tokens: [{"old":"/carts-with-images","type":0,"val":"carts-with-images","end":""}],
    types: placeholder as Registry['carts.list_carts_with_images']['types'],
  },
  'carts.get_images': {
    methods: ["GET","HEAD"],
    pattern: '/carts/:id/images',
    tokens: [{"old":"/carts/:id/images","type":0,"val":"carts","end":""},{"old":"/carts/:id/images","type":1,"val":"id","end":""},{"old":"/carts/:id/images","type":0,"val":"images","end":""}],
    types: placeholder as Registry['carts.get_images']['types'],
  },
  'carts.retrieve_cart': {
    methods: ["GET","HEAD"],
    pattern: '/carts/:id',
    tokens: [{"old":"/carts/:id","type":0,"val":"carts","end":""},{"old":"/carts/:id","type":1,"val":"id","end":""}],
    types: placeholder as Registry['carts.retrieve_cart']['types'],
  },
  'carts.get_customer_info': {
    methods: ["GET","HEAD"],
    pattern: '/carts/:id/customer-info',
    tokens: [{"old":"/carts/:id/customer-info","type":0,"val":"carts","end":""},{"old":"/carts/:id/customer-info","type":1,"val":"id","end":""},{"old":"/carts/:id/customer-info","type":0,"val":"customer-info","end":""}],
    types: placeholder as Registry['carts.get_customer_info']['types'],
  },
  'sellers.index': {
    methods: ["GET","HEAD"],
    pattern: '/sellers',
    tokens: [{"old":"/sellers","type":0,"val":"sellers","end":""}],
    types: placeholder as Registry['sellers.index']['types'],
  },
  'sellers.show': {
    methods: ["GET","HEAD"],
    pattern: '/sellers/:id',
    tokens: [{"old":"/sellers/:id","type":0,"val":"sellers","end":""},{"old":"/sellers/:id","type":1,"val":"id","end":""}],
    types: placeholder as Registry['sellers.show']['types'],
  },
  'stores.update_min_stock': {
    methods: ["PUT"],
    pattern: '/stores/:id/update-min-stock',
    tokens: [{"old":"/stores/:id/update-min-stock","type":0,"val":"stores","end":""},{"old":"/stores/:id/update-min-stock","type":1,"val":"id","end":""},{"old":"/stores/:id/update-min-stock","type":0,"val":"update-min-stock","end":""}],
    types: placeholder as Registry['stores.update_min_stock']['types'],
  },
  'stores.update_one_min_stock': {
    methods: ["PUT"],
    pattern: '/stores/:id/update-one-min-stock',
    tokens: [{"old":"/stores/:id/update-one-min-stock","type":0,"val":"stores","end":""},{"old":"/stores/:id/update-one-min-stock","type":1,"val":"id","end":""},{"old":"/stores/:id/update-one-min-stock","type":0,"val":"update-one-min-stock","end":""}],
    types: placeholder as Registry['stores.update_one_min_stock']['types'],
  },
  'stores.update_category_minimum_stock_compute': {
    methods: ["PUT"],
    pattern: '/stores/:id/compute-min-stock-values',
    tokens: [{"old":"/stores/:id/compute-min-stock-values","type":0,"val":"stores","end":""},{"old":"/stores/:id/compute-min-stock-values","type":1,"val":"id","end":""},{"old":"/stores/:id/compute-min-stock-values","type":0,"val":"compute-min-stock-values","end":""}],
    types: placeholder as Registry['stores.update_category_minimum_stock_compute']['types'],
  },
  'stores.get_store_categories_minimum_stock_computes': {
    methods: ["GET","HEAD"],
    pattern: '/stores/:id/compute-min-stock-values',
    tokens: [{"old":"/stores/:id/compute-min-stock-values","type":0,"val":"stores","end":""},{"old":"/stores/:id/compute-min-stock-values","type":1,"val":"id","end":""},{"old":"/stores/:id/compute-min-stock-values","type":0,"val":"compute-min-stock-values","end":""}],
    types: placeholder as Registry['stores.get_store_categories_minimum_stock_computes']['types'],
  },
  'stores.update_stream': {
    methods: ["PUT"],
    pattern: '/stores/:id/camera-streams',
    tokens: [{"old":"/stores/:id/camera-streams","type":0,"val":"stores","end":""},{"old":"/stores/:id/camera-streams","type":1,"val":"id","end":""},{"old":"/stores/:id/camera-streams","type":0,"val":"camera-streams","end":""}],
    types: placeholder as Registry['stores.update_stream']['types'],
  },
  'store_camera_configs.list_unify_hosts': {
    methods: ["GET","HEAD"],
    pattern: '/stores/camera-streams/unify-hosts',
    tokens: [{"old":"/stores/camera-streams/unify-hosts","type":0,"val":"stores","end":""},{"old":"/stores/camera-streams/unify-hosts","type":0,"val":"camera-streams","end":""},{"old":"/stores/camera-streams/unify-hosts","type":0,"val":"unify-hosts","end":""}],
    types: placeholder as Registry['store_camera_configs.list_unify_hosts']['types'],
  },
  'store_camera_configs.sync_unify_cameras': {
    methods: ["POST"],
    pattern: '/stores/:id/camera-streams/unify-hosts/:hostId/sync',
    tokens: [{"old":"/stores/:id/camera-streams/unify-hosts/:hostId/sync","type":0,"val":"stores","end":""},{"old":"/stores/:id/camera-streams/unify-hosts/:hostId/sync","type":1,"val":"id","end":""},{"old":"/stores/:id/camera-streams/unify-hosts/:hostId/sync","type":0,"val":"camera-streams","end":""},{"old":"/stores/:id/camera-streams/unify-hosts/:hostId/sync","type":0,"val":"unify-hosts","end":""},{"old":"/stores/:id/camera-streams/unify-hosts/:hostId/sync","type":1,"val":"hostId","end":""},{"old":"/stores/:id/camera-streams/unify-hosts/:hostId/sync","type":0,"val":"sync","end":""}],
    types: placeholder as Registry['store_camera_configs.sync_unify_cameras']['types'],
  },
  'store_camera_configs.restart_camera_runtime': {
    methods: ["POST"],
    pattern: '/stores/:id/camera-runtime/restart',
    tokens: [{"old":"/stores/:id/camera-runtime/restart","type":0,"val":"stores","end":""},{"old":"/stores/:id/camera-runtime/restart","type":1,"val":"id","end":""},{"old":"/stores/:id/camera-runtime/restart","type":0,"val":"camera-runtime","end":""},{"old":"/stores/:id/camera-runtime/restart","type":0,"val":"restart","end":""}],
    types: placeholder as Registry['store_camera_configs.restart_camera_runtime']['types'],
  },
  'store_camera_configs.create_store_camera_view_session': {
    methods: ["GET","HEAD"],
    pattern: '/stores/:id/camera-view-session',
    tokens: [{"old":"/stores/:id/camera-view-session","type":0,"val":"stores","end":""},{"old":"/stores/:id/camera-view-session","type":1,"val":"id","end":""},{"old":"/stores/:id/camera-view-session","type":0,"val":"camera-view-session","end":""}],
    types: placeholder as Registry['store_camera_configs.create_store_camera_view_session']['types'],
  },
  'store_camera_configs.set_camera_record_on_pre_auth': {
    methods: ["PATCH"],
    pattern: '/stores/:id/cameras/:cameraId/record-on-pre-auth',
    tokens: [{"old":"/stores/:id/cameras/:cameraId/record-on-pre-auth","type":0,"val":"stores","end":""},{"old":"/stores/:id/cameras/:cameraId/record-on-pre-auth","type":1,"val":"id","end":""},{"old":"/stores/:id/cameras/:cameraId/record-on-pre-auth","type":0,"val":"cameras","end":""},{"old":"/stores/:id/cameras/:cameraId/record-on-pre-auth","type":1,"val":"cameraId","end":""},{"old":"/stores/:id/cameras/:cameraId/record-on-pre-auth","type":0,"val":"record-on-pre-auth","end":""}],
    types: placeholder as Registry['store_camera_configs.set_camera_record_on_pre_auth']['types'],
  },
  'notifications.get_notifications': {
    methods: ["GET","HEAD"],
    pattern: '/notifications',
    tokens: [{"old":"/notifications","type":0,"val":"notifications","end":""}],
    types: placeholder as Registry['notifications.get_notifications']['types'],
  },
  'notifications.get_notification': {
    methods: ["GET","HEAD"],
    pattern: '/notifications/:id',
    tokens: [{"old":"/notifications/:id","type":0,"val":"notifications","end":""},{"old":"/notifications/:id","type":1,"val":"id","end":""}],
    types: placeholder as Registry['notifications.get_notification']['types'],
  },
  'notifications.send_notification': {
    methods: ["POST"],
    pattern: '/notifications/send',
    tokens: [{"old":"/notifications/send","type":0,"val":"notifications","end":""},{"old":"/notifications/send","type":0,"val":"send","end":""}],
    types: placeholder as Registry['notifications.send_notification']['types'],
  },
  'sellers.store': {
    methods: ["POST"],
    pattern: '/sellers',
    tokens: [{"old":"/sellers","type":0,"val":"sellers","end":""}],
    types: placeholder as Registry['sellers.store']['types'],
  },
  'sellers.update': {
    methods: ["PATCH"],
    pattern: '/sellers/:id',
    tokens: [{"old":"/sellers/:id","type":0,"val":"sellers","end":""},{"old":"/sellers/:id","type":1,"val":"id","end":""}],
    types: placeholder as Registry['sellers.update']['types'],
  },
  'sellers.destroy': {
    methods: ["DELETE"],
    pattern: '/sellers/:id',
    tokens: [{"old":"/sellers/:id","type":0,"val":"sellers","end":""},{"old":"/sellers/:id","type":1,"val":"id","end":""}],
    types: placeholder as Registry['sellers.destroy']['types'],
  },
  'stores.get_cpi_kiosks': {
    methods: ["GET","HEAD"],
    pattern: '/stores/cpi-kiosks/:reference',
    tokens: [{"old":"/stores/cpi-kiosks/:reference","type":0,"val":"stores","end":""},{"old":"/stores/cpi-kiosks/:reference","type":0,"val":"cpi-kiosks","end":""},{"old":"/stores/cpi-kiosks/:reference","type":1,"val":"reference","end":""}],
    types: placeholder as Registry['stores.get_cpi_kiosks']['types'],
  },
  'camera_views.list': {
    methods: ["GET","HEAD"],
    pattern: '/camera-views',
    tokens: [{"old":"/camera-views","type":0,"val":"camera-views","end":""}],
    types: placeholder as Registry['camera_views.list']['types'],
  },
  'camera_views.show': {
    methods: ["GET","HEAD"],
    pattern: '/camera-views/:id',
    tokens: [{"old":"/camera-views/:id","type":0,"val":"camera-views","end":""},{"old":"/camera-views/:id","type":1,"val":"id","end":""}],
    types: placeholder as Registry['camera_views.show']['types'],
  },
  'camera_views.create': {
    methods: ["POST"],
    pattern: '/camera-views',
    tokens: [{"old":"/camera-views","type":0,"val":"camera-views","end":""}],
    types: placeholder as Registry['camera_views.create']['types'],
  },
  'camera_views.update': {
    methods: ["PATCH"],
    pattern: '/camera-views/:id',
    tokens: [{"old":"/camera-views/:id","type":0,"val":"camera-views","end":""},{"old":"/camera-views/:id","type":1,"val":"id","end":""}],
    types: placeholder as Registry['camera_views.update']['types'],
  },
  'camera_views.destroy': {
    methods: ["DELETE"],
    pattern: '/camera-views/:id',
    tokens: [{"old":"/camera-views/:id","type":0,"val":"camera-views","end":""},{"old":"/camera-views/:id","type":1,"val":"id","end":""}],
    types: placeholder as Registry['camera_views.destroy']['types'],
  },
  'collaborators.get_all': {
    methods: ["GET","HEAD"],
    pattern: '/hr/collaborators',
    tokens: [{"old":"/hr/collaborators","type":0,"val":"hr","end":""},{"old":"/hr/collaborators","type":0,"val":"collaborators","end":""}],
    types: placeholder as Registry['collaborators.get_all']['types'],
  },
  'admins.list_api_keys': {
    methods: ["GET","HEAD"],
    pattern: '/admins/:adminId/api-keys',
    tokens: [{"old":"/admins/:adminId/api-keys","type":0,"val":"admins","end":""},{"old":"/admins/:adminId/api-keys","type":1,"val":"adminId","end":""},{"old":"/admins/:adminId/api-keys","type":0,"val":"api-keys","end":""}],
    types: placeholder as Registry['admins.list_api_keys']['types'],
  },
  'admins.generate_api_key': {
    methods: ["POST"],
    pattern: '/admins/:adminId/api-keys',
    tokens: [{"old":"/admins/:adminId/api-keys","type":0,"val":"admins","end":""},{"old":"/admins/:adminId/api-keys","type":1,"val":"adminId","end":""},{"old":"/admins/:adminId/api-keys","type":0,"val":"api-keys","end":""}],
    types: placeholder as Registry['admins.generate_api_key']['types'],
  },
  'admins.add_api_key_abilities': {
    methods: ["PATCH"],
    pattern: '/admins/:adminId/api-keys/:apiKeyId',
    tokens: [{"old":"/admins/:adminId/api-keys/:apiKeyId","type":0,"val":"admins","end":""},{"old":"/admins/:adminId/api-keys/:apiKeyId","type":1,"val":"adminId","end":""},{"old":"/admins/:adminId/api-keys/:apiKeyId","type":0,"val":"api-keys","end":""},{"old":"/admins/:adminId/api-keys/:apiKeyId","type":1,"val":"apiKeyId","end":""}],
    types: placeholder as Registry['admins.add_api_key_abilities']['types'],
  },
  'admins.revoke_api_key': {
    methods: ["DELETE"],
    pattern: '/admins/:adminId/api-keys/:apiKeyId',
    tokens: [{"old":"/admins/:adminId/api-keys/:apiKeyId","type":0,"val":"admins","end":""},{"old":"/admins/:adminId/api-keys/:apiKeyId","type":1,"val":"adminId","end":""},{"old":"/admins/:adminId/api-keys/:apiKeyId","type":0,"val":"api-keys","end":""},{"old":"/admins/:adminId/api-keys/:apiKeyId","type":1,"val":"apiKeyId","end":""}],
    types: placeholder as Registry['admins.revoke_api_key']['types'],
  },
  'visio_reviews.get_config': {
    methods: ["GET","HEAD"],
    pattern: '/visio-reviews/config',
    tokens: [{"old":"/visio-reviews/config","type":0,"val":"visio-reviews","end":""},{"old":"/visio-reviews/config","type":0,"val":"config","end":""}],
    types: placeholder as Registry['visio_reviews.get_config']['types'],
  },
  'visio_reviews.update_config': {
    methods: ["PATCH"],
    pattern: '/visio-reviews/config',
    tokens: [{"old":"/visio-reviews/config","type":0,"val":"visio-reviews","end":""},{"old":"/visio-reviews/config","type":0,"val":"config","end":""}],
    types: placeholder as Registry['visio_reviews.update_config']['types'],
  },
  'visio_reviews.get_global_charts': {
    methods: ["GET","HEAD"],
    pattern: '/visio-reviews/global-charts',
    tokens: [{"old":"/visio-reviews/global-charts","type":0,"val":"visio-reviews","end":""},{"old":"/visio-reviews/global-charts","type":0,"val":"global-charts","end":""}],
    types: placeholder as Registry['visio_reviews.get_global_charts']['types'],
  },
  'visio_reviews.get_operator_charts': {
    methods: ["GET","HEAD"],
    pattern: '/visio-reviews/operators/charts',
    tokens: [{"old":"/visio-reviews/operators/charts","type":0,"val":"visio-reviews","end":""},{"old":"/visio-reviews/operators/charts","type":0,"val":"operators","end":""},{"old":"/visio-reviews/operators/charts","type":0,"val":"charts","end":""}],
    types: placeholder as Registry['visio_reviews.get_operator_charts']['types'],
  },
  'visio_reviews.get_store_charts': {
    methods: ["GET","HEAD"],
    pattern: '/visio-reviews/stores/charts',
    tokens: [{"old":"/visio-reviews/stores/charts","type":0,"val":"visio-reviews","end":""},{"old":"/visio-reviews/stores/charts","type":0,"val":"stores","end":""},{"old":"/visio-reviews/stores/charts","type":0,"val":"charts","end":""}],
    types: placeholder as Registry['visio_reviews.get_store_charts']['types'],
  },
  'visio_reviews.get_filter_options': {
    methods: ["GET","HEAD"],
    pattern: '/visio-reviews/filter-options',
    tokens: [{"old":"/visio-reviews/filter-options","type":0,"val":"visio-reviews","end":""},{"old":"/visio-reviews/filter-options","type":0,"val":"filter-options","end":""}],
    types: placeholder as Registry['visio_reviews.get_filter_options']['types'],
  },
  'visio_reviews.get_recording_url': {
    methods: ["GET","HEAD"],
    pattern: '/visio-reviews/:reviewId/recording-url',
    tokens: [{"old":"/visio-reviews/:reviewId/recording-url","type":0,"val":"visio-reviews","end":""},{"old":"/visio-reviews/:reviewId/recording-url","type":1,"val":"reviewId","end":""},{"old":"/visio-reviews/:reviewId/recording-url","type":0,"val":"recording-url","end":""}],
    types: placeholder as Registry['visio_reviews.get_recording_url']['types'],
  },
  'visio_reviews.get_transcript': {
    methods: ["GET","HEAD"],
    pattern: '/visio-reviews/:reviewId/transcript',
    tokens: [{"old":"/visio-reviews/:reviewId/transcript","type":0,"val":"visio-reviews","end":""},{"old":"/visio-reviews/:reviewId/transcript","type":1,"val":"reviewId","end":""},{"old":"/visio-reviews/:reviewId/transcript","type":0,"val":"transcript","end":""}],
    types: placeholder as Registry['visio_reviews.get_transcript']['types'],
  },
  'sensors.index': {
    methods: ["GET","HEAD"],
    pattern: '/sensors',
    tokens: [{"old":"/sensors","type":0,"val":"sensors","end":""}],
    types: placeholder as Registry['sensors.index']['types'],
  },
  'sensors.fridges': {
    methods: ["GET","HEAD"],
    pattern: '/sensors/fridges',
    tokens: [{"old":"/sensors/fridges","type":0,"val":"sensors","end":""},{"old":"/sensors/fridges","type":0,"val":"fridges","end":""}],
    types: placeholder as Registry['sensors.fridges']['types'],
  },
  'sensors.show_fridge': {
    methods: ["GET","HEAD"],
    pattern: '/sensors/fridges/:id',
    tokens: [{"old":"/sensors/fridges/:id","type":0,"val":"sensors","end":""},{"old":"/sensors/fridges/:id","type":0,"val":"fridges","end":""},{"old":"/sensors/fridges/:id","type":1,"val":"id","end":""}],
    types: placeholder as Registry['sensors.show_fridge']['types'],
  },
  'sensors.history': {
    methods: ["GET","HEAD"],
    pattern: '/sensors/history',
    tokens: [{"old":"/sensors/history","type":0,"val":"sensors","end":""},{"old":"/sensors/history","type":0,"val":"history","end":""}],
    types: placeholder as Registry['sensors.history']['types'],
  },
  'sensors.active_alerts': {
    methods: ["GET","HEAD"],
    pattern: '/sensors/alerts',
    tokens: [{"old":"/sensors/alerts","type":0,"val":"sensors","end":""},{"old":"/sensors/alerts","type":0,"val":"alerts","end":""}],
    types: placeholder as Registry['sensors.active_alerts']['types'],
  },
  'sensors.acknowledge': {
    methods: ["PATCH"],
    pattern: '/sensors/alerts/:id/acknowledge',
    tokens: [{"old":"/sensors/alerts/:id/acknowledge","type":0,"val":"sensors","end":""},{"old":"/sensors/alerts/:id/acknowledge","type":0,"val":"alerts","end":""},{"old":"/sensors/alerts/:id/acknowledge","type":1,"val":"id","end":""},{"old":"/sensors/alerts/:id/acknowledge","type":0,"val":"acknowledge","end":""}],
    types: placeholder as Registry['sensors.acknowledge']['types'],
  },
  'sensors.alert_settings': {
    methods: ["GET","HEAD"],
    pattern: '/sensors/alert-settings',
    tokens: [{"old":"/sensors/alert-settings","type":0,"val":"sensors","end":""},{"old":"/sensors/alert-settings","type":0,"val":"alert-settings","end":""}],
    types: placeholder as Registry['sensors.alert_settings']['types'],
  },
  'sensors.update_alert_settings': {
    methods: ["PATCH"],
    pattern: '/sensors/alert-settings/:category',
    tokens: [{"old":"/sensors/alert-settings/:category","type":0,"val":"sensors","end":""},{"old":"/sensors/alert-settings/:category","type":0,"val":"alert-settings","end":""},{"old":"/sensors/alert-settings/:category","type":1,"val":"category","end":""}],
    types: placeholder as Registry['sensors.update_alert_settings']['types'],
  },
  'sensors.show': {
    methods: ["GET","HEAD"],
    pattern: '/sensors/:id',
    tokens: [{"old":"/sensors/:id","type":0,"val":"sensors","end":""},{"old":"/sensors/:id","type":1,"val":"id","end":""}],
    types: placeholder as Registry['sensors.show']['types'],
  },
  'carts.compute': {
    methods: ["POST"],
    pattern: '/carts/compute/:id?',
    tokens: [{"old":"/carts/compute/:id?","type":0,"val":"carts","end":""},{"old":"/carts/compute/:id?","type":0,"val":"compute","end":""},{"old":"/carts/compute/:id?","type":3,"val":"id","end":""}],
    types: placeholder as Registry['carts.compute']['types'],
  },
  'carts.cancel': {
    methods: ["POST"],
    pattern: '/carts/cancel/:id',
    tokens: [{"old":"/carts/cancel/:id","type":0,"val":"carts","end":""},{"old":"/carts/cancel/:id","type":0,"val":"cancel","end":""},{"old":"/carts/cancel/:id","type":1,"val":"id","end":""}],
    types: placeholder as Registry['carts.cancel']['types'],
  },
  'carts.validate': {
    methods: ["POST"],
    pattern: '/carts/validate/:id',
    tokens: [{"old":"/carts/validate/:id","type":0,"val":"carts","end":""},{"old":"/carts/validate/:id","type":0,"val":"validate","end":""},{"old":"/carts/validate/:id","type":1,"val":"id","end":""}],
    types: placeholder as Registry['carts.validate']['types'],
  },
  'carts.article_history': {
    methods: ["POST"],
    pattern: '/articles/history',
    tokens: [{"old":"/articles/history","type":0,"val":"articles","end":""},{"old":"/articles/history","type":0,"val":"history","end":""}],
    types: placeholder as Registry['carts.article_history']['types'],
  },
  'carts.advanced_article_infos': {
    methods: ["POST"],
    pattern: '/articles/advanced-infos',
    tokens: [{"old":"/articles/advanced-infos","type":0,"val":"articles","end":""},{"old":"/articles/advanced-infos","type":0,"val":"advanced-infos","end":""}],
    types: placeholder as Registry['carts.advanced_article_infos']['types'],
  },
  'staging_tools.get_test_account': {
    methods: ["GET","HEAD"],
    pattern: '/staging-tools/test-account',
    tokens: [{"old":"/staging-tools/test-account","type":0,"val":"staging-tools","end":""},{"old":"/staging-tools/test-account","type":0,"val":"test-account","end":""}],
    types: placeholder as Registry['staging_tools.get_test_account']['types'],
  },
  'staging_tools.toggle_test_account': {
    methods: ["POST"],
    pattern: '/staging-tools/test-account/toggle',
    tokens: [{"old":"/staging-tools/test-account/toggle","type":0,"val":"staging-tools","end":""},{"old":"/staging-tools/test-account/toggle","type":0,"val":"test-account","end":""},{"old":"/staging-tools/test-account/toggle","type":0,"val":"toggle","end":""}],
    types: placeholder as Registry['staging_tools.toggle_test_account']['types'],
  },
  'staging_tools.generate_test_account_qrcode': {
    methods: ["POST"],
    pattern: '/staging-tools/test-account/qrcode',
    tokens: [{"old":"/staging-tools/test-account/qrcode","type":0,"val":"staging-tools","end":""},{"old":"/staging-tools/test-account/qrcode","type":0,"val":"test-account","end":""},{"old":"/staging-tools/test-account/qrcode","type":0,"val":"qrcode","end":""}],
    types: placeholder as Registry['staging_tools.generate_test_account_qrcode']['types'],
  },
  'forecast.forecast_stores': {
    methods: ["GET","HEAD"],
    pattern: '/forecast/stores',
    tokens: [{"old":"/forecast/stores","type":0,"val":"forecast","end":""},{"old":"/forecast/stores","type":0,"val":"stores","end":""}],
    types: placeholder as Registry['forecast.forecast_stores']['types'],
  },
  'forecast.growth_forecast_store': {
    methods: ["GET","HEAD"],
    pattern: '/forecast/growth/stores/:id',
    tokens: [{"old":"/forecast/growth/stores/:id","type":0,"val":"forecast","end":""},{"old":"/forecast/growth/stores/:id","type":0,"val":"growth","end":""},{"old":"/forecast/growth/stores/:id","type":0,"val":"stores","end":""},{"old":"/forecast/growth/stores/:id","type":1,"val":"id","end":""}],
    types: placeholder as Registry['forecast.growth_forecast_store']['types'],
  },
  'forecast.forecast_store': {
    methods: ["GET","HEAD"],
    pattern: '/forecast/stores/:id',
    tokens: [{"old":"/forecast/stores/:id","type":0,"val":"forecast","end":""},{"old":"/forecast/stores/:id","type":0,"val":"stores","end":""},{"old":"/forecast/stores/:id","type":1,"val":"id","end":""}],
    types: placeholder as Registry['forecast.forecast_store']['types'],
  },
  'forecast.backtest_store': {
    methods: ["GET","HEAD"],
    pattern: '/forecast/stores/:id/backtest',
    tokens: [{"old":"/forecast/stores/:id/backtest","type":0,"val":"forecast","end":""},{"old":"/forecast/stores/:id/backtest","type":0,"val":"stores","end":""},{"old":"/forecast/stores/:id/backtest","type":1,"val":"id","end":""},{"old":"/forecast/stores/:id/backtest","type":0,"val":"backtest","end":""}],
    types: placeholder as Registry['forecast.backtest_store']['types'],
  },
  'forecast.backtest_aggregate': {
    methods: ["GET","HEAD"],
    pattern: '/forecast/backtest-aggregate',
    tokens: [{"old":"/forecast/backtest-aggregate","type":0,"val":"forecast","end":""},{"old":"/forecast/backtest-aggregate","type":0,"val":"backtest-aggregate","end":""}],
    types: placeholder as Registry['forecast.backtest_aggregate']['types'],
  },
  'forecast.store_typologies': {
    methods: ["GET","HEAD"],
    pattern: '/forecast/store-typologies',
    tokens: [{"old":"/forecast/store-typologies","type":0,"val":"forecast","end":""},{"old":"/forecast/store-typologies","type":0,"val":"store-typologies","end":""}],
    types: placeholder as Registry['forecast.store_typologies']['types'],
  },
  'stores.update_kpis': {
    methods: ["POST"],
    pattern: '/sync/update-store-kpis',
    tokens: [{"old":"/sync/update-store-kpis","type":0,"val":"sync","end":""},{"old":"/sync/update-store-kpis","type":0,"val":"update-store-kpis","end":""}],
    types: placeholder as Registry['stores.update_kpis']['types'],
  },
  'internal_categories.all': {
    methods: ["GET","HEAD"],
    pattern: '/internal-categories',
    tokens: [{"old":"/internal-categories","type":0,"val":"internal-categories","end":""}],
    types: placeholder as Registry['internal_categories.all']['types'],
  },
  'internal_categories.create': {
    methods: ["POST"],
    pattern: '/internal-categories',
    tokens: [{"old":"/internal-categories","type":0,"val":"internal-categories","end":""}],
    types: placeholder as Registry['internal_categories.create']['types'],
  },
  'internal_categories.update': {
    methods: ["PATCH"],
    pattern: '/internal-categories/:id',
    tokens: [{"old":"/internal-categories/:id","type":0,"val":"internal-categories","end":""},{"old":"/internal-categories/:id","type":1,"val":"id","end":""}],
    types: placeholder as Registry['internal_categories.update']['types'],
  },
  'internal_categories.delete': {
    methods: ["DELETE"],
    pattern: '/internal-categories/:id',
    tokens: [{"old":"/internal-categories/:id","type":0,"val":"internal-categories","end":""},{"old":"/internal-categories/:id","type":1,"val":"id","end":""}],
    types: placeholder as Registry['internal_categories.delete']['types'],
  },
  'reappro_category_groups.index': {
    methods: ["GET","HEAD"],
    pattern: '/reappro-category-groups',
    tokens: [{"old":"/reappro-category-groups","type":0,"val":"reappro-category-groups","end":""}],
    types: placeholder as Registry['reappro_category_groups.index']['types'],
  },
  'reappro_category_groups.store': {
    methods: ["POST"],
    pattern: '/reappro-category-groups',
    tokens: [{"old":"/reappro-category-groups","type":0,"val":"reappro-category-groups","end":""}],
    types: placeholder as Registry['reappro_category_groups.store']['types'],
  },
  'reappro_category_groups.update': {
    methods: ["PATCH"],
    pattern: '/reappro-category-groups/:id',
    tokens: [{"old":"/reappro-category-groups/:id","type":0,"val":"reappro-category-groups","end":""},{"old":"/reappro-category-groups/:id","type":1,"val":"id","end":""}],
    types: placeholder as Registry['reappro_category_groups.update']['types'],
  },
  'reappro_category_groups.destroy': {
    methods: ["DELETE"],
    pattern: '/reappro-category-groups/:id',
    tokens: [{"old":"/reappro-category-groups/:id","type":0,"val":"reappro-category-groups","end":""},{"old":"/reappro-category-groups/:id","type":1,"val":"id","end":""}],
    types: placeholder as Registry['reappro_category_groups.destroy']['types'],
  },
  'store_product_reappro_params.index': {
    methods: ["GET","HEAD"],
    pattern: '/store-product-reappro-params',
    tokens: [{"old":"/store-product-reappro-params","type":0,"val":"store-product-reappro-params","end":""}],
    types: placeholder as Registry['store_product_reappro_params.index']['types'],
  },
  'store_product_reappro_params.upsert': {
    methods: ["PUT"],
    pattern: '/store-product-reappro-params',
    tokens: [{"old":"/store-product-reappro-params","type":0,"val":"store-product-reappro-params","end":""}],
    types: placeholder as Registry['store_product_reappro_params.upsert']['types'],
  },
  'platform_stocks.index': {
    methods: ["GET","HEAD"],
    pattern: '/platform-stocks',
    tokens: [{"old":"/platform-stocks","type":0,"val":"platform-stocks","end":""}],
    types: placeholder as Registry['platform_stocks.index']['types'],
  },
  'platform_stocks.declare': {
    methods: ["POST"],
    pattern: '/platform-stocks',
    tokens: [{"old":"/platform-stocks","type":0,"val":"platform-stocks","end":""}],
    types: placeholder as Registry['platform_stocks.declare']['types'],
  },
  'platform_stocks.distinct_products': {
    methods: ["GET","HEAD"],
    pattern: '/platform-stocks/distinct-products',
    tokens: [{"old":"/platform-stocks/distinct-products","type":0,"val":"platform-stocks","end":""},{"old":"/platform-stocks/distinct-products","type":0,"val":"distinct-products","end":""}],
    types: placeholder as Registry['platform_stocks.distinct_products']['types'],
  },
  'platform_stocks.distinct_lots': {
    methods: ["GET","HEAD"],
    pattern: '/platform-stocks/distinct-lots',
    tokens: [{"old":"/platform-stocks/distinct-lots","type":0,"val":"platform-stocks","end":""},{"old":"/platform-stocks/distinct-lots","type":0,"val":"distinct-lots","end":""}],
    types: placeholder as Registry['platform_stocks.distinct_lots']['types'],
  },
  'platform_stocks.get_logs': {
    methods: ["GET","HEAD"],
    pattern: '/platform-stocks/:id/logs',
    tokens: [{"old":"/platform-stocks/:id/logs","type":0,"val":"platform-stocks","end":""},{"old":"/platform-stocks/:id/logs","type":1,"val":"id","end":""},{"old":"/platform-stocks/:id/logs","type":0,"val":"logs","end":""}],
    types: placeholder as Registry['platform_stocks.get_logs']['types'],
  },
  'platform_stocks.destroy': {
    methods: ["DELETE"],
    pattern: '/platform-stocks/:id',
    tokens: [{"old":"/platform-stocks/:id","type":0,"val":"platform-stocks","end":""},{"old":"/platform-stocks/:id","type":1,"val":"id","end":""}],
    types: placeholder as Registry['platform_stocks.destroy']['types'],
  },
  'platform_stocks.destroy_log': {
    methods: ["DELETE"],
    pattern: '/platform-stock-logs/:id',
    tokens: [{"old":"/platform-stock-logs/:id","type":0,"val":"platform-stock-logs","end":""},{"old":"/platform-stock-logs/:id","type":1,"val":"id","end":""}],
    types: placeholder as Registry['platform_stocks.destroy_log']['types'],
  },
  'platform_stocks.revert_log': {
    methods: ["POST"],
    pattern: '/platform-stock-logs/:id/revert',
    tokens: [{"old":"/platform-stock-logs/:id/revert","type":0,"val":"platform-stock-logs","end":""},{"old":"/platform-stock-logs/:id/revert","type":1,"val":"id","end":""},{"old":"/platform-stock-logs/:id/revert","type":0,"val":"revert","end":""}],
    types: placeholder as Registry['platform_stocks.revert_log']['types'],
  },
  'opening_sessions.index': {
    methods: ["GET","HEAD"],
    pattern: '/opening-sessions',
    tokens: [{"old":"/opening-sessions","type":0,"val":"opening-sessions","end":""}],
    types: placeholder as Registry['opening_sessions.index']['types'],
  },
  'opening_sessions.get_recordings': {
    methods: ["GET","HEAD"],
    pattern: '/opening-sessions/:sessionId/recordings',
    tokens: [{"old":"/opening-sessions/:sessionId/recordings","type":0,"val":"opening-sessions","end":""},{"old":"/opening-sessions/:sessionId/recordings","type":1,"val":"sessionId","end":""},{"old":"/opening-sessions/:sessionId/recordings","type":0,"val":"recordings","end":""}],
    types: placeholder as Registry['opening_sessions.get_recordings']['types'],
  },
  'opening_sessions.retain': {
    methods: ["POST"],
    pattern: '/opening-sessions/:id/retain',
    tokens: [{"old":"/opening-sessions/:id/retain","type":0,"val":"opening-sessions","end":""},{"old":"/opening-sessions/:id/retain","type":1,"val":"id","end":""},{"old":"/opening-sessions/:id/retain","type":0,"val":"retain","end":""}],
    types: placeholder as Registry['opening_sessions.retain']['types'],
  },
  'opening_sessions.release': {
    methods: ["POST"],
    pattern: '/opening-sessions/:id/release',
    tokens: [{"old":"/opening-sessions/:id/release","type":0,"val":"opening-sessions","end":""},{"old":"/opening-sessions/:id/release","type":1,"val":"id","end":""},{"old":"/opening-sessions/:id/release","type":0,"val":"release","end":""}],
    types: placeholder as Registry['opening_sessions.release']['types'],
  },
  'stores.index': {
    methods: ["GET","HEAD"],
    pattern: '/stores',
    tokens: [{"old":"/stores","type":0,"val":"stores","end":""}],
    types: placeholder as Registry['stores.index']['types'],
  },
  'stores.show': {
    methods: ["GET","HEAD"],
    pattern: '/stores/:id',
    tokens: [{"old":"/stores/:id","type":0,"val":"stores","end":""},{"old":"/stores/:id","type":1,"val":"id","end":""}],
    types: placeholder as Registry['stores.show']['types'],
  },
  'stores.store': {
    methods: ["POST"],
    pattern: '/stores',
    tokens: [{"old":"/stores","type":0,"val":"stores","end":""}],
    types: placeholder as Registry['stores.store']['types'],
  },
  'stores.update': {
    methods: ["PUT","PATCH"],
    pattern: '/stores/:id',
    tokens: [{"old":"/stores/:id","type":0,"val":"stores","end":""},{"old":"/stores/:id","type":1,"val":"id","end":""}],
    types: placeholder as Registry['stores.update']['types'],
  },
  'store_tags.index': {
    methods: ["GET","HEAD"],
    pattern: '/store-tags',
    tokens: [{"old":"/store-tags","type":0,"val":"store-tags","end":""}],
    types: placeholder as Registry['store_tags.index']['types'],
  },
  'store_tags.store': {
    methods: ["POST"],
    pattern: '/store-tags',
    tokens: [{"old":"/store-tags","type":0,"val":"store-tags","end":""}],
    types: placeholder as Registry['store_tags.store']['types'],
  },
  'pre_projects.index': {
    methods: ["GET","HEAD"],
    pattern: '/pre-project-cities',
    tokens: [{"old":"/pre-project-cities","type":0,"val":"pre-project-cities","end":""}],
    types: placeholder as Registry['pre_projects.index']['types'],
  },
  'pre_projects.import': {
    methods: ["POST"],
    pattern: '/pre-projects/import',
    tokens: [{"old":"/pre-projects/import","type":0,"val":"pre-projects","end":""},{"old":"/pre-projects/import","type":0,"val":"import","end":""}],
    types: placeholder as Registry['pre_projects.import']['types'],
  },
  'pre_projects.update_count': {
    methods: ["PATCH"],
    pattern: '/pre-projects/:id',
    tokens: [{"old":"/pre-projects/:id","type":0,"val":"pre-projects","end":""},{"old":"/pre-projects/:id","type":1,"val":"id","end":""}],
    types: placeholder as Registry['pre_projects.update_count']['types'],
  },
  'pre_projects.destroy_city': {
    methods: ["DELETE"],
    pattern: '/cities/:id',
    tokens: [{"old":"/cities/:id","type":0,"val":"cities","end":""},{"old":"/cities/:id","type":1,"val":"id","end":""}],
    types: placeholder as Registry['pre_projects.destroy_city']['types'],
  },
  'pre_projects.update_city': {
    methods: ["PATCH"],
    pattern: '/cities/:id',
    tokens: [{"old":"/cities/:id","type":0,"val":"cities","end":""},{"old":"/cities/:id","type":1,"val":"id","end":""}],
    types: placeholder as Registry['pre_projects.update_city']['types'],
  },
  'store_projects.index': {
    methods: ["GET","HEAD"],
    pattern: '/store-projects',
    tokens: [{"old":"/store-projects","type":0,"val":"store-projects","end":""}],
    types: placeholder as Registry['store_projects.index']['types'],
  },
  'store_projects.store': {
    methods: ["POST"],
    pattern: '/store-projects',
    tokens: [{"old":"/store-projects","type":0,"val":"store-projects","end":""}],
    types: placeholder as Registry['store_projects.store']['types'],
  },
  'store_projects.update': {
    methods: ["PUT","PATCH"],
    pattern: '/store-projects/:id',
    tokens: [{"old":"/store-projects/:id","type":0,"val":"store-projects","end":""},{"old":"/store-projects/:id","type":1,"val":"id","end":""}],
    types: placeholder as Registry['store_projects.update']['types'],
  },
  'store_projects.destroy': {
    methods: ["DELETE"],
    pattern: '/store-projects/:id',
    tokens: [{"old":"/store-projects/:id","type":0,"val":"store-projects","end":""},{"old":"/store-projects/:id","type":1,"val":"id","end":""}],
    types: placeholder as Registry['store_projects.destroy']['types'],
  },
  'store_projects.update_position': {
    methods: ["PATCH"],
    pattern: '/store-projects/:id/position',
    tokens: [{"old":"/store-projects/:id/position","type":0,"val":"store-projects","end":""},{"old":"/store-projects/:id/position","type":1,"val":"id","end":""},{"old":"/store-projects/:id/position","type":0,"val":"position","end":""}],
    types: placeholder as Registry['store_projects.update_position']['types'],
  },
  'store_projects.get_store_ca_over_days': {
    methods: ["GET","HEAD"],
    pattern: '/store-projects/stores/:storeRef/ca/:days',
    tokens: [{"old":"/store-projects/stores/:storeRef/ca/:days","type":0,"val":"store-projects","end":""},{"old":"/store-projects/stores/:storeRef/ca/:days","type":0,"val":"stores","end":""},{"old":"/store-projects/stores/:storeRef/ca/:days","type":1,"val":"storeRef","end":""},{"old":"/store-projects/stores/:storeRef/ca/:days","type":0,"val":"ca","end":""},{"old":"/store-projects/stores/:storeRef/ca/:days","type":1,"val":"days","end":""}],
    types: placeholder as Registry['store_projects.get_store_ca_over_days']['types'],
  },
  'store_projects.delete_photo': {
    methods: ["DELETE"],
    pattern: '/store-projects/:id/delete-photo',
    tokens: [{"old":"/store-projects/:id/delete-photo","type":0,"val":"store-projects","end":""},{"old":"/store-projects/:id/delete-photo","type":1,"val":"id","end":""},{"old":"/store-projects/:id/delete-photo","type":0,"val":"delete-photo","end":""}],
    types: placeholder as Registry['store_projects.delete_photo']['types'],
  },
  'store_projects.delete_document': {
    methods: ["DELETE"],
    pattern: '/store-projects/:id/delete-document',
    tokens: [{"old":"/store-projects/:id/delete-document","type":0,"val":"store-projects","end":""},{"old":"/store-projects/:id/delete-document","type":1,"val":"id","end":""},{"old":"/store-projects/:id/delete-document","type":0,"val":"delete-document","end":""}],
    types: placeholder as Registry['store_projects.delete_document']['types'],
  },
  'store_projects.rename_document': {
    methods: ["PATCH"],
    pattern: '/store-projects/:id/rename-document',
    tokens: [{"old":"/store-projects/:id/rename-document","type":0,"val":"store-projects","end":""},{"old":"/store-projects/:id/rename-document","type":1,"val":"id","end":""},{"old":"/store-projects/:id/rename-document","type":0,"val":"rename-document","end":""}],
    types: placeholder as Registry['store_projects.rename_document']['types'],
  },
  'real_estate_tasks.index': {
    methods: ["GET","HEAD"],
    pattern: '/real-estate-tasks',
    tokens: [{"old":"/real-estate-tasks","type":0,"val":"real-estate-tasks","end":""}],
    types: placeholder as Registry['real_estate_tasks.index']['types'],
  },
  'real_estate_tasks.store': {
    methods: ["POST"],
    pattern: '/real-estate-tasks',
    tokens: [{"old":"/real-estate-tasks","type":0,"val":"real-estate-tasks","end":""}],
    types: placeholder as Registry['real_estate_tasks.store']['types'],
  },
  'real_estate_tasks.update': {
    methods: ["PUT","PATCH"],
    pattern: '/real-estate-tasks/:id',
    tokens: [{"old":"/real-estate-tasks/:id","type":0,"val":"real-estate-tasks","end":""},{"old":"/real-estate-tasks/:id","type":1,"val":"id","end":""}],
    types: placeholder as Registry['real_estate_tasks.update']['types'],
  },
  'real_estate_tasks.destroy': {
    methods: ["DELETE"],
    pattern: '/real-estate-tasks/:id',
    tokens: [{"old":"/real-estate-tasks/:id","type":0,"val":"real-estate-tasks","end":""},{"old":"/real-estate-tasks/:id","type":1,"val":"id","end":""}],
    types: placeholder as Registry['real_estate_tasks.destroy']['types'],
  },
  'tasks.update_position': {
    methods: ["PATCH"],
    pattern: '/real-estate-tasks/:id/position',
    tokens: [{"old":"/real-estate-tasks/:id/position","type":0,"val":"real-estate-tasks","end":""},{"old":"/real-estate-tasks/:id/position","type":1,"val":"id","end":""},{"old":"/real-estate-tasks/:id/position","type":0,"val":"position","end":""}],
    types: placeholder as Registry['tasks.update_position']['types'],
  },
  'real_estate_events.index': {
    methods: ["GET","HEAD"],
    pattern: '/real-estate-events',
    tokens: [{"old":"/real-estate-events","type":0,"val":"real-estate-events","end":""}],
    types: placeholder as Registry['real_estate_events.index']['types'],
  },
  'real_estate_events.store': {
    methods: ["POST"],
    pattern: '/real-estate-events',
    tokens: [{"old":"/real-estate-events","type":0,"val":"real-estate-events","end":""}],
    types: placeholder as Registry['real_estate_events.store']['types'],
  },
  'real_estate_events.update': {
    methods: ["PUT","PATCH"],
    pattern: '/real-estate-events/:id',
    tokens: [{"old":"/real-estate-events/:id","type":0,"val":"real-estate-events","end":""},{"old":"/real-estate-events/:id","type":1,"val":"id","end":""}],
    types: placeholder as Registry['real_estate_events.update']['types'],
  },
  'real_estate_events.destroy': {
    methods: ["DELETE"],
    pattern: '/real-estate-events/:id',
    tokens: [{"old":"/real-estate-events/:id","type":0,"val":"real-estate-events","end":""},{"old":"/real-estate-events/:id","type":1,"val":"id","end":""}],
    types: placeholder as Registry['real_estate_events.destroy']['types'],
  },
  'contacts.index': {
    methods: ["GET","HEAD"],
    pattern: '/contacts',
    tokens: [{"old":"/contacts","type":0,"val":"contacts","end":""}],
    types: placeholder as Registry['contacts.index']['types'],
  },
  'contacts.store': {
    methods: ["POST"],
    pattern: '/contacts',
    tokens: [{"old":"/contacts","type":0,"val":"contacts","end":""}],
    types: placeholder as Registry['contacts.store']['types'],
  },
  'contacts.update': {
    methods: ["PATCH"],
    pattern: '/contacts/:id',
    tokens: [{"old":"/contacts/:id","type":0,"val":"contacts","end":""},{"old":"/contacts/:id","type":1,"val":"id","end":""}],
    types: placeholder as Registry['contacts.update']['types'],
  },
  'contacts.destroy': {
    methods: ["DELETE"],
    pattern: '/contacts/:id',
    tokens: [{"old":"/contacts/:id","type":0,"val":"contacts","end":""},{"old":"/contacts/:id","type":1,"val":"id","end":""}],
    types: placeholder as Registry['contacts.destroy']['types'],
  },
  'referenced_brand_categories.index': {
    methods: ["GET","HEAD"],
    pattern: '/referenced-brand-categories',
    tokens: [{"old":"/referenced-brand-categories","type":0,"val":"referenced-brand-categories","end":""}],
    types: placeholder as Registry['referenced_brand_categories.index']['types'],
  },
  'referenced_brands.index': {
    methods: ["GET","HEAD"],
    pattern: '/referenced-brands',
    tokens: [{"old":"/referenced-brands","type":0,"val":"referenced-brands","end":""}],
    types: placeholder as Registry['referenced_brands.index']['types'],
  },
  'referenced_brands.scrape': {
    methods: ["POST"],
    pattern: '/referenced-brands/scrape',
    tokens: [{"old":"/referenced-brands/scrape","type":0,"val":"referenced-brands","end":""},{"old":"/referenced-brands/scrape","type":0,"val":"scrape","end":""}],
    types: placeholder as Registry['referenced_brands.scrape']['types'],
  },
  'referenced_brands.stats': {
    methods: ["GET","HEAD"],
    pattern: '/referenced-brands/stats',
    tokens: [{"old":"/referenced-brands/stats","type":0,"val":"referenced-brands","end":""},{"old":"/referenced-brands/stats","type":0,"val":"stats","end":""}],
    types: placeholder as Registry['referenced_brands.stats']['types'],
  },
  'referenced_brand_pois.index': {
    methods: ["GET","HEAD"],
    pattern: '/referenced-brand-pois',
    tokens: [{"old":"/referenced-brand-pois","type":0,"val":"referenced-brand-pois","end":""}],
    types: placeholder as Registry['referenced_brand_pois.index']['types'],
  },
  'interest_zone_runs.index': {
    methods: ["GET","HEAD"],
    pattern: '/interest-zone-runs',
    tokens: [{"old":"/interest-zone-runs","type":0,"val":"interest-zone-runs","end":""}],
    types: placeholder as Registry['interest_zone_runs.index']['types'],
  },
  'interest_zone_runs.store': {
    methods: ["POST"],
    pattern: '/interest-zone-runs',
    tokens: [{"old":"/interest-zone-runs","type":0,"val":"interest-zone-runs","end":""}],
    types: placeholder as Registry['interest_zone_runs.store']['types'],
  },
  'interest_zone_runs.show': {
    methods: ["GET","HEAD"],
    pattern: '/interest-zone-runs/:key',
    tokens: [{"old":"/interest-zone-runs/:key","type":0,"val":"interest-zone-runs","end":""},{"old":"/interest-zone-runs/:key","type":1,"val":"key","end":""}],
    types: placeholder as Registry['interest_zone_runs.show']['types'],
  },
  'interest_zone_runs.destroy': {
    methods: ["DELETE"],
    pattern: '/interest-zone-runs/:key',
    tokens: [{"old":"/interest-zone-runs/:key","type":0,"val":"interest-zone-runs","end":""},{"old":"/interest-zone-runs/:key","type":1,"val":"key","end":""}],
    types: placeholder as Registry['interest_zone_runs.destroy']['types'],
  },
  'interest_zone_saved_maps.index': {
    methods: ["GET","HEAD"],
    pattern: '/interest-zone-saved-maps',
    tokens: [{"old":"/interest-zone-saved-maps","type":0,"val":"interest-zone-saved-maps","end":""}],
    types: placeholder as Registry['interest_zone_saved_maps.index']['types'],
  },
  'interest_zone_saved_maps.store': {
    methods: ["POST"],
    pattern: '/interest-zone-saved-maps',
    tokens: [{"old":"/interest-zone-saved-maps","type":0,"val":"interest-zone-saved-maps","end":""}],
    types: placeholder as Registry['interest_zone_saved_maps.store']['types'],
  },
  'interest_zone_saved_maps.show': {
    methods: ["GET","HEAD"],
    pattern: '/interest-zone-saved-maps/:id',
    tokens: [{"old":"/interest-zone-saved-maps/:id","type":0,"val":"interest-zone-saved-maps","end":""},{"old":"/interest-zone-saved-maps/:id","type":1,"val":"id","end":""}],
    types: placeholder as Registry['interest_zone_saved_maps.show']['types'],
  },
  'interest_zone_saved_maps.update': {
    methods: ["PATCH"],
    pattern: '/interest-zone-saved-maps/:id',
    tokens: [{"old":"/interest-zone-saved-maps/:id","type":0,"val":"interest-zone-saved-maps","end":""},{"old":"/interest-zone-saved-maps/:id","type":1,"val":"id","end":""}],
    types: placeholder as Registry['interest_zone_saved_maps.update']['types'],
  },
  'interest_zone_saved_maps.destroy': {
    methods: ["DELETE"],
    pattern: '/interest-zone-saved-maps/:id',
    tokens: [{"old":"/interest-zone-saved-maps/:id","type":0,"val":"interest-zone-saved-maps","end":""},{"old":"/interest-zone-saved-maps/:id","type":1,"val":"id","end":""}],
    types: placeholder as Registry['interest_zone_saved_maps.destroy']['types'],
  },
  'interest_zone_saved_maps.add_zones': {
    methods: ["POST"],
    pattern: '/interest-zone-saved-maps/:id/zones',
    tokens: [{"old":"/interest-zone-saved-maps/:id/zones","type":0,"val":"interest-zone-saved-maps","end":""},{"old":"/interest-zone-saved-maps/:id/zones","type":1,"val":"id","end":""},{"old":"/interest-zone-saved-maps/:id/zones","type":0,"val":"zones","end":""}],
    types: placeholder as Registry['interest_zone_saved_maps.add_zones']['types'],
  },
  'interest_zone_saved_maps.remove_zone': {
    methods: ["DELETE"],
    pattern: '/interest-zone-saved-maps/:id/zones/:zoneId',
    tokens: [{"old":"/interest-zone-saved-maps/:id/zones/:zoneId","type":0,"val":"interest-zone-saved-maps","end":""},{"old":"/interest-zone-saved-maps/:id/zones/:zoneId","type":1,"val":"id","end":""},{"old":"/interest-zone-saved-maps/:id/zones/:zoneId","type":0,"val":"zones","end":""},{"old":"/interest-zone-saved-maps/:id/zones/:zoneId","type":1,"val":"zoneId","end":""}],
    types: placeholder as Registry['interest_zone_saved_maps.remove_zone']['types'],
  },
  'mailing_lists.index': {
    methods: ["GET","HEAD"],
    pattern: '/mailing-lists',
    tokens: [{"old":"/mailing-lists","type":0,"val":"mailing-lists","end":""}],
    types: placeholder as Registry['mailing_lists.index']['types'],
  },
  'mailing_lists.show': {
    methods: ["GET","HEAD"],
    pattern: '/mailing-lists/:key',
    tokens: [{"old":"/mailing-lists/:key","type":0,"val":"mailing-lists","end":""},{"old":"/mailing-lists/:key","type":1,"val":"key","end":""}],
    types: placeholder as Registry['mailing_lists.show']['types'],
  },
  'mailing_lists.add_recipient': {
    methods: ["POST"],
    pattern: '/mailing-lists/:key/recipients',
    tokens: [{"old":"/mailing-lists/:key/recipients","type":0,"val":"mailing-lists","end":""},{"old":"/mailing-lists/:key/recipients","type":1,"val":"key","end":""},{"old":"/mailing-lists/:key/recipients","type":0,"val":"recipients","end":""}],
    types: placeholder as Registry['mailing_lists.add_recipient']['types'],
  },
  'mailing_lists.update_recipient': {
    methods: ["PATCH"],
    pattern: '/mailing-lists/recipients/:id',
    tokens: [{"old":"/mailing-lists/recipients/:id","type":0,"val":"mailing-lists","end":""},{"old":"/mailing-lists/recipients/:id","type":0,"val":"recipients","end":""},{"old":"/mailing-lists/recipients/:id","type":1,"val":"id","end":""}],
    types: placeholder as Registry['mailing_lists.update_recipient']['types'],
  },
  'mailing_lists.destroy_recipient': {
    methods: ["DELETE"],
    pattern: '/mailing-lists/recipients/:id',
    tokens: [{"old":"/mailing-lists/recipients/:id","type":0,"val":"mailing-lists","end":""},{"old":"/mailing-lists/recipients/:id","type":0,"val":"recipients","end":""},{"old":"/mailing-lists/recipients/:id","type":1,"val":"id","end":""}],
    types: placeholder as Registry['mailing_lists.destroy_recipient']['types'],
  },
  'project_tracking.board': {
    methods: ["GET","HEAD"],
    pattern: '/project-tracking/board',
    tokens: [{"old":"/project-tracking/board","type":0,"val":"project-tracking","end":""},{"old":"/project-tracking/board","type":0,"val":"board","end":""}],
    types: placeholder as Registry['project_tracking.board']['types'],
  },
  'project_tracking.production': {
    methods: ["GET","HEAD"],
    pattern: '/project-tracking/production',
    tokens: [{"old":"/project-tracking/production","type":0,"val":"project-tracking","end":""},{"old":"/project-tracking/production","type":0,"val":"production","end":""}],
    types: placeholder as Registry['project_tracking.production']['types'],
  },
  'project_tracking.dashboard': {
    methods: ["GET","HEAD"],
    pattern: '/project-tracking/dashboard',
    tokens: [{"old":"/project-tracking/dashboard","type":0,"val":"project-tracking","end":""},{"old":"/project-tracking/dashboard","type":0,"val":"dashboard","end":""}],
    types: placeholder as Registry['project_tracking.dashboard']['types'],
  },
  'project_tracking.syntheses': {
    methods: ["GET","HEAD"],
    pattern: '/project-tracking/syntheses',
    tokens: [{"old":"/project-tracking/syntheses","type":0,"val":"project-tracking","end":""},{"old":"/project-tracking/syntheses","type":0,"val":"syntheses","end":""}],
    types: placeholder as Registry['project_tracking.syntheses']['types'],
  },
  'project_tracking.show_ticket': {
    methods: ["GET","HEAD"],
    pattern: '/project-tracking/tickets/:id',
    tokens: [{"old":"/project-tracking/tickets/:id","type":0,"val":"project-tracking","end":""},{"old":"/project-tracking/tickets/:id","type":0,"val":"tickets","end":""},{"old":"/project-tracking/tickets/:id","type":1,"val":"id","end":""}],
    types: placeholder as Registry['project_tracking.show_ticket']['types'],
  },
  'project_tracking.validate_ticket': {
    methods: ["POST"],
    pattern: '/project-tracking/tickets/:id/validate',
    tokens: [{"old":"/project-tracking/tickets/:id/validate","type":0,"val":"project-tracking","end":""},{"old":"/project-tracking/tickets/:id/validate","type":0,"val":"tickets","end":""},{"old":"/project-tracking/tickets/:id/validate","type":1,"val":"id","end":""},{"old":"/project-tracking/tickets/:id/validate","type":0,"val":"validate","end":""}],
    types: placeholder as Registry['project_tracking.validate_ticket']['types'],
  },
  'project_tracking.report_issue': {
    methods: ["POST"],
    pattern: '/project-tracking/tickets/:id/issue',
    tokens: [{"old":"/project-tracking/tickets/:id/issue","type":0,"val":"project-tracking","end":""},{"old":"/project-tracking/tickets/:id/issue","type":0,"val":"tickets","end":""},{"old":"/project-tracking/tickets/:id/issue","type":1,"val":"id","end":""},{"old":"/project-tracking/tickets/:id/issue","type":0,"val":"issue","end":""}],
    types: placeholder as Registry['project_tracking.report_issue']['types'],
  },
  'project_tracking.add_comment': {
    methods: ["POST"],
    pattern: '/project-tracking/tickets/:id/comments',
    tokens: [{"old":"/project-tracking/tickets/:id/comments","type":0,"val":"project-tracking","end":""},{"old":"/project-tracking/tickets/:id/comments","type":0,"val":"tickets","end":""},{"old":"/project-tracking/tickets/:id/comments","type":1,"val":"id","end":""},{"old":"/project-tracking/tickets/:id/comments","type":0,"val":"comments","end":""}],
    types: placeholder as Registry['project_tracking.add_comment']['types'],
  },
} as const satisfies Record<string, AdonisEndpoint>

export { routes }

export const registry = {
  routes,
  $tree: {} as ApiDefinition,
}

declare module '@tuyau/core/types' {
  export interface UserRegistry {
    routes: typeof routes
    $tree: ApiDefinition
  }
}
